import Link from "next/link"
import Stack from "@mui/material/Stack"
import { MAX_FILTER_SHOW } from "./FilterType"
import { useMemo, useState } from "react";
import OpenInFullIcon from '@mui/icons-material/OpenInFull';
import CloseFullscreenIcon from '@mui/icons-material/CloseFullscreen';
import dynamic from "next/dynamic";
import { useLayoutData } from "../../../../utils/contexts/LayoutContext";
import { FindButtonProps, FindExpandLinkProps } from "../FindDesignTypes";
import FindFilterMobileListItem from "../FindFilterMobileListItem";
import { filterUrl } from "../Find";
import { PageType } from "../../../../pages/_app";
import { FilterOptionsProps } from "../Find.types";

const FilterOptions = ({
  filters,
  colors,
  pageUrl,
  mmbr,
  isMobile,
  closeSubmenu
}: FilterOptionsProps) => {
  const { partnerSiteFull, templatePath } = useLayoutData()

  const path = templatePath === PageType.RBhuPP ? `${templatePath}/templates/${partnerSiteFull?.content?.templateId ?? 'AutoraTemplate'}` : templatePath

  const FindButton = useMemo(() => dynamic<FindButtonProps>(() => import(`../../../../design/${path}/_findDesign/Design`).then((style) => style.FindButton)), [path])
  const FindExpandLink = useMemo(() => dynamic<FindExpandLinkProps>(() => import(`../../../../design/${path}/_findDesign/Design`).then((style) => style.FindExpandLink)), [path])

  const [showAll, setShowAll] = useState<boolean>(false);
  const length = filters?.items && filters?.items?.length > MAX_FILTER_SHOW ? MAX_FILTER_SHOW : filters?.items?.length
  const maxLength = showAll ? filters?.items?.length : length

  return (
    <>
      {isMobile ? (
        <>
          {filters?.items?.map((item, i) => (
              <FindFilterMobileListItem
                key={i}
                filters={filters}
                item={item}
                colors={colors}
                pageUrl={pageUrl}
                mmbr={mmbr}
                closeSubmenu={closeSubmenu}
              />
            )
          )}
        </>
      ) : (
        <>
          {filters?.items?.slice(0, maxLength).map((item, i) => {
            return item.disabled ? (
              <FindButton 
                bgcolor={colors.mainColor}
                bghovercolor={colors.secondaryColor}
                variant="outlined"
                filterbutton={1}
                selected={item?.selected ? 1 : 0}
                disabled={item.disabled}
                aria-label={item.title}
              >
                {item.title}
                <span>({item.count})</span>
              </FindButton>
            ) : (
              <Link key={i} href={filterUrl(filters, item, undefined, pageUrl, mmbr)} scroll={false} passHref>
                <a>
                  <FindButton 
                    bgcolor={colors.mainColor}
                    bghovercolor={colors.secondaryColor}
                    variant="outlined"
                    filterbutton={1}
                    selected={item?.selected ? 1 : 0}
                    aria-label={item.title}
                  >
                    {item.title}
                    <span>({item.count})</span>
                  </FindButton>
                </a>
              </Link>
            )
          })}
          {filters?.items && filters?.items?.length > MAX_FILTER_SHOW ? (
            <FindExpandLink component={"span"} onClick={() => setShowAll(!showAll)}>
              <Stack display={"inline-flex"} flexDirection={"row"} alignItems={"center"}>
                <Stack mr={1}>{showAll ? <CloseFullscreenIcon /> : <OpenInFullIcon />}</Stack>
                <Stack>{showAll ? "Mutass kevesebbet" : "Mutasd mindet"}</Stack>            
              </Stack>
            </FindExpandLink>
          ) : null}
        </>
      )}
    </>
  )
}

export default FilterOptions